/** 품의 v2 응답의 다국어 문자열 처리 */

export type Lang = 'ko' | 'en' | 'zh';
export type I18nText = Record<Lang, string | null>;

/** i18next.language ('en-US', 'zh-CN' 등) → 응답 객체 key (`ko`/`en`/`zh`) */
export const normalizeLang = (i18nLang: string | undefined): Lang => {
  if (!i18nLang) return 'ko';
  const lower = i18nLang.toLowerCase();
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('zh')) return 'zh';
  return 'ko';
};

export const pickI18nText = (
  value: Partial<Record<Lang, string | null>> | string | null | undefined,
  lang: Lang,
): string => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value[lang] ?? value.ko ?? '';
};
